@use "diy_base.module.scss";
@use "foundation/responsive";
@use "foundation/colors";

.step-fields-selector {
  @include responsive.phone {
    width: diy_base.$box-width-phone;
    padding: 0 20px;
  }

  .step-fields-container {
    margin: 2em auto 0;
    padding: 0;
    width: 25.555555556em; /* any change should be replicated in .brand-description */
    color: #fff;
    text-align: left;
    border-radius: diy_base.$border-radius;

    h3 {
      margin-top: 0;
    }

    .cta {
      @include diy_base.centralized-button();
    }

    @include responsive.phone {
      width: unset;

      max-width: 25.555555556em;
    }
  }

  ul.fields {
    text-align: left;

  }

  :global .growing-text-area textarea {
    overflow: auto;
    &::-webkit-scrollbar { width: 0 !important }
  }

  .make-it-your-own {
    background-color: rgba(0, 0, 0, 0.25);
    color: colors.$ifttt-next-dark-bg-text-color;
    padding: 15px;
    font-size: 14px;
    margin-top: 0.71em; // 10px
    border-radius: 0.71em; // 10px

    .cta {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
